export async function navigationRequest<T>(path: string, init?: RequestInit): Promise<T> {
    const response = await fetch(`/api/navigation${path}`, { cache: "no-store", ...init });
    const body = await response.json().catch(() => null);
    if (!response.ok) throw new Error(body?.error ?? `Помилка сервера: ${response.status}`);
    if (!body) throw new Error("Сервер повернув порожню відповідь.");
    return body as T;
}

export function editorHeaders(token: string): HeadersInit {
    return { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
}

export function errorMessage(error: unknown): string {
    return error instanceof Error ? error.message : "Не вдалося виконати запит.";
}
